import styled from "styled-components";
import { FormRow, InputContainer } from "../../../components/Form/Styles";
import SelectField from "../../../components/Select/Select";
import ArrowDownFilter from "../../../assets/images/arrow_down_filter.svg";

export const FiltersContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin: 2% auto;
  flex-direction: column;

  ${({ theme }) => theme.smartphone} {
    margin-top: 5%;
    width: 90%;
  }
`;

export const FieldsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  padding-left: 16px;
  padding-right: 16px;
  gap: 16px;
  ${({ theme }) => theme.smartphone} {
    flex-direction: column;
    padding-left: 0;
    padding-right: 0;
  }
`;

export const FilterFormRow = styled(FormRow)`
  margin: 0;
  display: flex;
  justify-content: space-between;
  width: 33%;
  height: 40px;
  overflow: hidden;
  border-radius: 5px;
  ${({ theme }) => theme.smartphone} {
    width: 100%;
    margin-bottom: 8px;
  }
`;

export const FilterInputContainer = styled(InputContainer)`
  background-color: ${({ theme }) => theme.white};
  width: 100%;
  height: 40px;
  border-radius: 5px;
  ${({ theme }) => theme.smartphone} {
    width: ${({ widthSmartphone }) =>
      widthSmartphone ? `${widthSmartphone}%` : "100%"};
  }
`;

export const FilterSelect = styled(SelectField)`
  height: 40px;
  &::after {
    background: url(${ArrowDownFilter}) no-repeat center !important;
    background-size: 12px 19px !important;
    width: 12px !important;
    height: 19px !important;
    right: 16px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    transition: transform 0.2s ease;
    pointer-events: none;
  }
  &:focus-within::after {
    transform: translateY(-50%) rotate(180deg) !important;
  }
  select {
    color: #475061;
    font-family: "Nunito";
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    padding: 10px 16px;
    padding-right: 40px;
    height: 40px;
    border-radius: 5px;
    background-color: white;
  }
`;

export const FilterDatePickerWrapper = styled.div`
  width: 100%;
  height: 40px;
  background: white;
  border-radius: 5px;
  display: flex;
  align-items: center;
  overflow: hidden;

  .react-datepicker-wrapper {
    width: 100%;
  }
  .react-datepicker__input-container input {
    color: #475061;
    font-family: "Nunito";
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    padding: 8px 16px !important;
    height: 40px;
    border-radius: 5px;
    border: none;
    outline: none;
    width: 100%;
    background: white;
  }

  .react-datepicker__input-container input::placeholder {
    color: #475061;
    opacity: 1;
  }

  .react-datepicker__input-container input:disabled,
  .react-datepicker__input-container input:disabled::placeholder {
    color: ${({ theme }) => theme.silverChalice};
    opacity: 1;
  }

  /* Calendar icon sizing */
  > div > div:last-child {
    padding-right: 16px;
  }
  img {
    width: 24px !important;
    height: 24px !important;
  }
`;

export const Spacer = styled.div`
  width: 10px;
  ${({ theme }) => theme.smartphone} {
    display: none;
  }
`;

export const LinkText = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  border-radius: 48px;
  cursor: pointer;
  color: #0bbef0;
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-decoration: underline;
  margin-top: 16px;
  opacity: ${({ $disabled }) => ($disabled ? 0.3 : 1)};
  pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};
  ${({ theme }) => theme.smartphone} {
    font-size: 14px;
  }
`;

export const FilterIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-left: 8px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
`;

export const FilterButton = styled.button`
  border: 2px solid white;
  background-color: white;
  border-radius: 48px;
  width: 20%;
  height: 40px;
  padding: 8px 16px;
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 800;
  line-height: 24px;
  color: #0bbef0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  &:disabled {
    cursor: not-allowed;
    color: #0bbef0;
    background-color: #ffffff;
    border-color: #ffffff;
    opacity: 0.3;
  }
  ${({ theme }) => theme.smartphone} {
    height: 38px;
    font-size: 14px;
    width: 50%;
  }
`;
